import React from "react";
import { Navigate } from "react-router-dom";
import AdminRulesPage from "./admin";
import { getUserInfo } from "../../helpers/user";

const RulesPageRouteWrapper = () => {
    const userInfo = getUserInfo();

    if (userInfo.role === "admin") {
        return <AdminRulesPage />;
    } else if (userInfo.role === "user" || userInfo.role === "org_admin") {
        return <Navigate to="/" />;
    } else {
        return <Navigate to="/login" />;
    }
};

export default RulesPageRouteWrapper;
